export default "__VITE_ASSET__DUK77TTM__"